module.exports = __webpack_public_path__ + "img/log_light_2.2d1fcb79.png";